import { render } from "./TransportBoxCar.vue?vue&type=template&id=53d56c7a&ts=true"
import script from "./TransportBoxCar.vue?vue&type=script&lang=ts"
export * from "./TransportBoxCar.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Work\\АСУП\\OptiLoadingPaper\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__